"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFailureModes = void 0;
const capability_1 = require("../../capability");
const _util_1 = require("../_util");
const getFailureModes = (device) => {
    const alarms = device.alarms.map(({ alarm }) => alarm);
    return {
        sanitization: [],
        dripTrayAndLeak: [(0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.Flooding)],
        enhancements: [],
        heatingStatus: [],
        chillingStatus: [],
        waterQuality: [],
    };
};
exports.getFailureModes = getFailureModes;
//# sourceMappingURL=failure-mode.js.map